import { Component, Inject } from "@angular/core";
import { AdminService } from "../../app/services/admin.service";
import {
  ENV_VARS,
  EnvironmentVariables
} from "../../app/environment-variables/environment-variables.module";
import {
  IDiaprofilUser,
  DIAPROFIL_QUESTIONNAIRE_UUID
} from "../../app/models/types";
import { FhirService } from "../../app/services/fhir.service";
import { forkJoin } from "rxjs/observable/forkJoin";
import { switchMap } from "rxjs/operators/switchMap";
import { mergeMap } from "rxjs/operators";
import { LoadingController } from "ionic-angular/components/loading/loading-controller";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { takeUntil } from "rxjs/operator/takeUntil";
import { first } from "rxjs/operators/first";
import { NavController } from "ionic-angular/navigation/nav-controller";
import { PatientPage } from "../patient.page/patient.page";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { TranslateService } from "@ngx-translate/core";
import { QuestionnaireResponseService } from "@zitelab/ionic-fhir-questionnaires";
import { DashboardService } from "../../app/services/dashboard.service";
import { map } from "rxjs/operator/map";
import {
  EventLoggingService,
  LogEventId
} from "../../app/services/event-logging.service";
import { CurrentConsultationsPage } from "../current-consultations.page/current-consultations.page";

@Component({
  selector: "home-page",
  templateUrl: "home.page.html"
})
export class HomePage {
  versionNumber: string;
  buildTimeStamp: string;
  query: string = null;
  queryResults: fhir.Patient[] = [];
  queryFocus: boolean = true;
  latestFiveResponses: {
    patient: IDiaprofilUser;
    response: fhir.QuestionnaireResponse;
  }[] = [];
  logoUrl: string = "assets/imgs/home_page_logo.svg";
  constructor(
    public admin: AdminService,
    private eventLogging: EventLoggingService,
    public fhir: FhirService,
    public loadingCtrl: LoadingController,
    public store: Store<AppState>,
    public navCtrl: NavController,
    public translate: TranslateService,
    public questionnaireResponseService: QuestionnaireResponseService,
    public dashboard: DashboardService,
    @Inject(ENV_VARS) public envVars: EnvironmentVariables
  ) {
    this.versionNumber = envVars.VERSION_NUMBER;
    this.buildTimeStamp = envVars.BUILD_TIMESTAMP;
  }

  onQueryInput() {
    console.log(this.query);
    if (this.query === null || this.query.length <= 1) {
      return;
    }
    const queries = [
      this.fhir.getQuery({
        resourceType: "Patient",
        queryString: `name=${this.query}`
      }),
      this.fhir.getQuery({
        resourceType: "Patient",
        queryString: `identifier=${this.query.replace("-", "")}`
      })
    ];
    forkJoin(queries)
      .pipe(
        mergeMap(result => {
          const patients = [];
          result.map(bundle => {
            if (bundle.total > 0) {
              bundle.entry.map(entry => patients.push(entry.resource));
            }
          });
          this.queryResults = patients as fhir.Patient[];
          return result;
        })
      )
      .subscribe();
  }

  onQueryCancel() {
    this.queryResults = [];
  }

  toggleQueryFocus(status: boolean) {
    setTimeout(() => {
      this.queryFocus = status;
    }, 200); // The small delay is to allow click event on search results
  }

  ionViewWillEnter() {
    this.eventLogging.saveEvent({
      event_id: LogEventId.OPEN_HOME_PAGE,
      event_src_location: "HomePage"
    });
    this.getLastFiveProAnswers();
    this.admin.fetchNews();
    this.admin.fetchServiceMessages();
  }

  getLastFiveProAnswers(): void {
    this.fhir
      .getQuery({
        resourceType: "QuestionnaireResponse",
        queryParams: {
          questionnaire: `Questionnaire/${DIAPROFIL_QUESTIONNAIRE_UUID}`,
          _sort: "-authored",
          _count: 5
        }
      })
      .subscribe(bundle => {
        const resources: fhir.QuestionnaireResponse[] = [];
        if (bundle.total > 0) {
          bundle.entry.map(entry =>
            resources.push(entry.resource as fhir.QuestionnaireResponse)
          );
        }
        const fhirIds = resources
          .map(resource => resource.subject.reference)
          .join(",");
        this.admin.getUsers({
          userType: "Patient",
          organizationUuid: this.admin.userState.organizationUuid,
          fhirId: fhirIds,
          extraAction: users => {
            const responseMapping = [];
            resources.map(resource => {
              const curUser = users.find(
                user => user.fhir_id === resource.subject.reference
              );
              responseMapping.push({
                patient: curUser,
                response: resource
              });
            });
            this.latestFiveResponses = responseMapping;
          }
        });
      });
  }

  goToPatientPage(selectedPatientId: string) {
    const loading = this.loadingCtrl.create({
      content: this.translate.instant("GENERIC_UI.LOADING"),
      dismissOnPageChange: true
    });
    loading.present();
    this.admin.getUsers({
      userType: "Patient",
      organizationUuid: this.admin.userState.organizationUuid,
      fhirId: `Patient/${selectedPatientId}`,
      extraAction: users => {
        this.admin.addPatientsToStore(users);
        this.store
          .select(state => state.patients)
          .pipe(
            first(
              patients =>
                patients.find(
                  patient => patient.fhirResource.id === selectedPatientId
                ) !== undefined
            )
          )
          .subscribe(patients => {
            const patient = patients.find(
              patient => patient.fhirResource.id === selectedPatientId
            );
            const diaprofilPatient = new DiaprofilPatient(
              patient,
              this.translate,
              this.questionnaireResponseService,
              this.dashboard
            );
            this.navCtrl.push(PatientPage, { patient: diaprofilPatient });
          });
      }
    });
  }

  toCurrentConsultationsPage() {
    this.navCtrl.push(CurrentConsultationsPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/home.page/home.page.ts